module.exports = __webpack_public_path__ + "static/media/jon-tyson-228428-unsplash.6fcf94ae.jpg";